<div class="flex-center">
    <div class="align-center">
        <img src="assets/images/no-report.png" 
        class="empty-state-image"
        alt="empty state image">
        &nbsp;
        <div class="empty-state-header">No Reports Found</div>
    </div>
</div>
